module.exports = __webpack_public_path__ + "img/Fullscreen.2151a138.svg";